import React from 'react'
import { SurfacePalette, type } from '../tokens'

interface Props {
  palette: SurfacePalette
  label: string
  /** Tile/row-level hover reveal: hidden at 0 opacity until parent `.group:hover`. */
  hideUntilGroupHover?: boolean
}

const BubbleIcon = ({ size = 12 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M14 9.5A2.5 2.5 0 0 1 11.5 12H5l-3 3V4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v5Z" />
  </svg>
)

export const CommentIndicator = ({ palette, label, hideUntilGroupHover }: Props) => (
  <button
    type="button"
    data-comment-trigger="true"
    aria-label={`Comments on ${label}`}
    className={
      hideUntilGroupHover
        ? 'opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity'
        : ''
    }
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      padding: '2px 6px',
      margin: 0,
      background: 'transparent',
      border: 'none',
      cursor: 'pointer',
      color: palette.textMuted,
      fontFamily: type.family.mono,
      fontSize: type.size.eyebrow,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
    }}
  >
    <BubbleIcon />
    Comment
  </button>
)
